import { render } from "./dashboard-adm.vue?vue&type=template&id=049fe30f&ts=true"
import script from "./dashboard-adm.vue?vue&type=script&lang=ts"
export * from "./dashboard-adm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__